module.exports = __webpack_public_path__ + "static/media/typography_400x700.78dfacd7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/assets/typography_400x700.jpg
 ** module id = 164
 ** module chunks = 0
 **/